import type { ReactNode } from 'react'
import React from 'react'

import { Button, CircularProgress } from '@mui/material'

interface ActionButtonProps {
  onClick: () => void
  caption?: string
  startIcon?: ReactNode
  disabled?: boolean
  isLoading?: boolean
  dataControlId?: string
}

function ActionButton({
  onClick,
  caption = '登録',
  startIcon,
  disabled,
  isLoading = false,
  dataControlId,
}: ActionButtonProps) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={isLoading ? <CircularProgress size={12} color="primary" /> : startIcon}
      disabled={disabled || isLoading}
      data-control-id={dataControlId}
    >
      {caption}
    </Button>
  )
}

export default ActionButton
